module.exports = __webpack_public_path__ + "assets/logo.b991d06d.svg";